import { registerAction } from '../../Action'

const LOAD_MESSAGE = 'LOAD_MESSAGE'

const creator = (annotationId, message) => ({ annotationId, message })

const reducer = (state = {}, action) => ({
  ...state,
  jsonApiEntities: {
    ...state.jsonApiEntities,
    annotation: {
      ...state.jsonApiEntities.annotation,
      [action.payload.annotationId]: {
        ...state.jsonApiEntities.annotation[action.payload.annotationId],
        relationships: {
          ...state.jsonApiEntities.annotation[action.payload.annotationId]
            .relationships,
          messages: [{ id: action.payload.message.id, type: 'message' }],
        },
      },
    },
  },
})

const loadMessage = registerAction(LOAD_MESSAGE, { reducer, creator })

export default loadMessage
